export const Reveal4DErrors = {
    None: 0,
    UserMustBeRootAdmin: 156,
}
